module.exports = __webpack_public_path__ + "img/29_24.bf83c19f.png";